import {push} from "connected-react-router";

const receivedDataAnalysis = () => push("/analysis/received-data");

export const gotoReceivedDataAnalysis = {
  receivedDataAnalysis: receivedDataAnalysis,
};
